__turbopack_context__.v({
  "login": "LoginModal-module__wJBzzW__login",
  "loginWrapper": "LoginModal-module__wJBzzW__loginWrapper",
});
